export default {
  menu: 'App company info',
  title: 'App company info',

  general: {
    notifications: {
      edit: {
        success: 'Company info information updated successfully'
      },

      parseError: {
        name: 'Company name is not valid',
        country: 'Country is not valid',
        province: 'State is not valid',
        city: 'City is not valid',
        address: 'Address is not valid',
        postCode: 'Post code is not valid',
        supportNumber: 'Phone number is not valid',
        whatsAppNumber: 'WhatsApp support is not valid'
      }
    },

    validators: {
      imageSize: 'The selected file size is too large',
      fileFormat: 'The selected file format is not allowed',
      name: 'Name is not valid',
      requiredFieldEmpty: 'Required fields is empty or wrong'
    }
  },

  profile: {
    title: 'App profile',
    dynamicTitle: '{name} profile',

    importantData: {
      manager: 'Manager',
      status: 'Status',
      balance: 'Balance',
      expiredAt: 'Expired at'
    },

    actions: {
      dashboard: 'Dashboard',
      invoices: 'Invoices',
      logs: 'Activity logs'
    }
  },

  dashboard: {
    title: 'App company dashboard',

    general: {
      labels: {
        documents: 'Documents count',
        users: 'Users count',
        costs: 'Costs count',
        internal_funds: 'Internal funds count',
        payments: 'Payments count',
        receives: 'Receives count',
        purchase_invoices: 'Purchase invoices count',
        return_purchase_invoices: 'Purchase refund invoices count',
        sale_invoices: 'Sale invoices count',
        return_sale_invoices: 'Sale refund invoices count',
        storeroom_receipts: 'Delivery notes count',
        storeroom_deficits: 'Deficits count',
        storeroom_surplus: 'Surplus count',
        storeroom_conversions: 'Conversions count'
      }
    }
  },

  invoices: {
    title: 'App company invoices',

    general: {
      table: {
        header: {
          id: 'Number',
          receivedId: 'Reference',
          creator: 'Creator',
          app: 'App',
          date: 'Date',
          finalPrice: 'Grand Amt',
          status: 'Status',
          lastModifiedDate: 'Update',
          restore: 'Restore',
          delete: 'Delete'
        },

        filters: {
          type: {
            all: 'All',
            present: 'Retail',
            tel: 'Telephone',
            internet: 'Internet'
          },
          status: {
            all: 'All',
            draft: 'Draft',
            payed: 'Paid'
          }
        }
      },

      processTypes: {
        draft: 'Draft',
        payed: 'Paid'
      }
    }
  },

  edit: {
    title: 'Edit company info',

    general: {
      labels: {
        generalInfo: 'General info',
        telInfo: 'Tell info',
        financialInfo: 'Financial info',
        uploadLogo: 'Upload logo',
        preview: 'Preview:',
        name: 'Company name',
        managerName: 'Manager full name',
        country: 'Country',
        province: 'State',
        city: 'City',
        address: 'Address',
        postCode: 'Post code',
        phoneNumber: 'Phone number',
        whatsAppSupport: 'WhatsApp support',
        managerPhoneNumber: 'Manager phone number'
      },

      description: {
        logoRule: 'Authorized JPG, JPEG or PNG formats. Maximum logo size 800 KB ',
        generalInfo: 'This box displays the general information of the company.',
        telInfo: 'In this box the company contact information is displayed.',
        financialInfo: 'This box displays the companys financial information.'
      }
    }
  }
}
